import React, { Component } from 'react';
import {
  CardContainer,
  CardWrapper,
  CardHeader,
  ElementTitle,
  ElementTitleWrapper,
  CardBody,
  BodyInfo,
  NomCapa,
  InfoDesc,
  CardFooter,
  Parametre,
  CardEditInput,
  CardEditButtonWrapper,
  NomParametreEdit
} from './InformacioPuntCardElement';

import { createFeature, getFeatureFields, updateFeature } from '../Utils/EdicioCapaUtils';
import { toast } from 'react-toastify';
import { getTranslatedKey } from '../Utils/TranslateUtils';
import { ButtonStyle } from '../Navbar/Compartir/Componentes/Download/Load/LocalMaps/LocalMapsElement';

export default class EditCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      configuration: {}
    };
  }

  componentDidMount = async () => {
    if (this.props.isEditing.type === 'edit') {
      const types = await getFeatureFields(this.props.layer);
      const props = this.props.layer.getProperties().map((prop) => prop.name);
      const filtered = types.filter((item) => props.includes(item.field));
      let config = {};
      for (let key in this.props.editFeature.values_) {
        if (key !== 'geometry') {
          config[key] = this.props.editFeature.values_[key];
        }
      }
      if (this.props.editCardProps) {
        Object.keys(config).forEach((key) => {
          if (this.props.editCardProps.hasOwnProperty(key)) {
            config[key] = this.props.editCardProps[key];
          }
        });
      }

      this.setState({ fields: filtered, configuration: config });
    } else {
      const fields = await getFeatureFields(this.props.layer);
      const props = this.props.layer.getProperties().map((prop) => prop.name);
      const filtered = fields.filter((item) => props.includes(item.field));

      const config = {};
      fields.forEach((ele) => {
        config[ele.field] = undefined;
      });
      for (let key in config) {
        config[key] = undefined;
      }
      if (this.props.editCardProps) {
        Object.keys(config).forEach((key) => {
          if (this.props.editCardProps.hasOwnProperty(key)) {
            config[key] = this.props.editCardProps[key];
          }
        });
      }

      this.setState({ fields: filtered, configuration: config });
    }
  };

  inputType = (value) => {
    if (value !== 'número') {
      return 'text';
    } else {
      return 'number';
    }
  };

  objChange = (key, value) => {
    this.setState((prevState) => ({
      configuration: {
        ...prevState.configuration,
        [key]: value
      }
    }));
  };

  fieldsCheck = () => {
    let required = [];
    this.state.fields.forEach((field) => {
      if (field.nullable === false && !this.state.configuration[field.field]) {
        required.push(field.field);
      }
    });
    return required;
  };

  onAccept = () => {
    let emptyFields = this.fieldsCheck();
    if (emptyFields.length > 0) {
      let message;
      if (emptyFields.length === 1) {
        message = `El camp ${emptyFields[0]} és obligatori`;
      } else {
        message = `Els camps ${emptyFields.join(', ')} són obligatoris`;
      }
      toast.warn(message);
      return;
    }
    if (this.props.type === 'create') {
      createFeature(this.props.layer, this.props.editVector.getSource(), this.props.editFeature, this.state.configuration);
    } else if (this.props.type === 'edit') {
      updateFeature(this.props.layer, this.props.editVector.getSource(), this.props.editFeature, this.state.configuration);
    }
    this.props.setEditing(false, this.props.layer);
  };

  render() {
    return (
      <>
        <CardContainer id={`editCard`} altura={this.props.altura} mobile={window.innerWidth < 768} selected={this.props.selected}>
          <CardWrapper id={`edit-info-card-wrapper`} altura={this.props.altura}>
            <CardHeader id={`edit-info-card-header`}>
              <ElementTitleWrapper>
                <NomCapa title={this.props.layer.getName()} class={'nomCapa' + this.props.nomCapa} fontSizeEnabled={this.props.fontSizeEnabled}>
                  {this.props.layer.getName()}
                </NomCapa>
                <ElementTitle title={this.state.toolTip} class="toolTipCapa" id={`edit-info-card-title`} fontSizeEnabled={this.props.fontSizeEnabled}>
                  {getTranslatedKey('edition')}
                </ElementTitle>
              </ElementTitleWrapper>
            </CardHeader>
            <CardBody id={`edit-info-card-body`}>
              <BodyInfo id={`edit-info-card-body-info`}>
                <InfoDesc id={`edit-info-card-body-desc`} fontSizeEnabled={this.props.fontSizeEnabled}>
                  {this.state.fields.length > 0 &&
                    this.state.fields.map((fieldObject) => {
                      let key = fieldObject.field;
                      let type = fieldObject.type;
                      let isNullable = fieldObject.nullable;

                      let properties = this.props.layer.getProperties();
                      let property = properties.find((property) => property.name === key);
                      if (type === 'número' || type === 'text') {
                        return (
                          <Parametre
                            title={key + (!isNullable ? ' (camp obligatori)' : '')}
                            class="atributeElement"
                            fontSizeEnabled={this.props.fontSizeEnabled}>
                            <NomParametreEdit>{(property?.alias || key) + (!isNullable ? '* : ' : ': ')}</NomParametreEdit>
                            <CardEditInput
                              type={this.inputType(type)}
                              value={this.state.configuration[key]}
                              placeholder={type}
                              onChange={(e) => this.objChange(key, e.target.type === 'number' ? parseFloat(e.target.value) : e.target.value)}
                            />
                          </Parametre>
                        );
                      } else {
                        return null;
                      }
                    })}
                </InfoDesc>
              </BodyInfo>
            </CardBody>
            <CardFooter id={`edit-info-card-footer`}>
              <CardEditButtonWrapper>
                <ButtonStyle onClick={() => this.props.setEditing(false, this.props.layer)}>{getTranslatedKey('cancel')}</ButtonStyle>
                <ButtonStyle onClick={() => this.onAccept()}>{getTranslatedKey('save')}</ButtonStyle>
              </CardEditButtonWrapper>
            </CardFooter>
          </CardWrapper>
        </CardContainer>
      </>
    );
  }
}
